import { Box } from '@mui/material';
import React from 'react';
import ExpenseRangeGraph from './ExpenseRangeGraph';
import SalesRangeGraph from './SalesRangeGraph';
import InventoryRangeGraph from './InventoryRangeGraph';
import EnquiryRangeGraph from './EnquiryRangeGraph';

const DashboardAnalytics = () => {
  return (
    <>
      <Box
        m='2rem 0'
        display='grid'
        gridTemplateColumns='repeat(2, 1fr)'
        sx={{
          gap: '0.5rem 0.5rem',
        }}
      >
        <Box
          display='flex'
          flexDirection='column'
          width='100%'
          className='bg-slate-50 rounded-lg p-2 border-slate-500 align-middle h-auto'
          sx={{
            border: '1px solid',
          }}
        >
          <h4 className='text-center font-extrabold text-[0.72rem] leading-[0.5rem] text-[#1F509A] mt-3'>
            Cars Sold w.r.t Days
          </h4>
          <InventoryRangeGraph />
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          width='100%'
          className='bg-slate-50 rounded-lg p-2 border-slate-500 align-middle h-auto'
          sx={{
            border: '1px solid',
          }}
        >
          <h4 className='text-center font-extrabold text-[0.72rem] leading-[0.5rem] text-[#666] mt-3'>
            Enquiries Generated w.r.t Days
          </h4>
          <EnquiryRangeGraph />
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          width='100%'
          className='bg-slate-50 rounded-lg p-2 border-slate-500 align-middle h-auto'
          sx={{
            border: '1px solid',
          }}
        >
          <h4 className='text-center font-extrabold text-[0.72rem] leading-[0.5rem] text-[#666] mt-3'>
            Sales(₹) w.r.t Days
          </h4>
          <SalesRangeGraph />
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          width='100%'
          className='bg-slate-50 rounded-lg p-2 border-slate-500 align-middle h-auto'
          sx={{
            border: '1px solid',
          }}
        >
          <h4 className='text-center font-extrabold text-[0.72rem] leading-[0.5rem] text-[#666] mt-3'>
            Expenses(₹) w.r.t Days
          </h4>
          <ExpenseRangeGraph />
        </Box>
      </Box>
    </>
  );
};

export default DashboardAnalytics;
